import React from 'react';

import { SkeletonBlock } from '../../../components/skeleton/skeleton';

function OrdersSkeleton({ showCompanyColumn = false, rows = 10 }) {
  return (
    <div className="mt-8 flex flex-col" aria-hidden="true">
      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle px-4 md:px-6 lg:px-8">
          <table className="min-w-full divide-y divide-gray-300 dark:divide-slate-500">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0 dark:text-slate-200"
                >
                  Receipt#
                </th>
                {showCompanyColumn && (
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0 dark:text-slate-200"
                  >
                    Company
                  </th>
                )}
                <th
                  scope="col"
                  className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0 dark:text-slate-200"
                >
                  Customer
                </th>
                <th
                  scope="col"
                  className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0 dark:text-slate-200"
                >
                  Details
                </th>
                <th
                  scope="col"
                  className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900 dark:text-slate-200"
                >
                  Payment Status
                </th>
                <th
                  scope="col"
                  className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900 dark:text-slate-200"
                >
                  Time
                </th>
                <th
                  scope="col"
                  className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900 dark:text-slate-200"
                >
                  Order Type
                </th>
                <th
                  scope="col"
                  className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900 dark:text-slate-200"
                >
                  Total
                </th>
                <th
                  scope="col"
                  className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900 dark:text-slate-200"
                >
                  Order Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-slate-500">
              {[...Array(rows)].map((_, idx) => (
                <tr key={idx}>
                  <td className="whitespace-nowrap py-4 pl-4 pr-3 sm:pl-6 md:pl-0">
                    <SkeletonBlock className="h-4 w-20 rounded" />
                  </td>
                  {showCompanyColumn && (
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 sm:pl-6 md:pl-0">
                      <SkeletonBlock className="h-4 w-28 rounded" />
                    </td>
                  )}
                  <td className="whitespace-nowrap py-4 pl-4 pr-3 sm:pl-6 md:pl-0">
                    <div className="space-y-2">
                      <SkeletonBlock className="h-4 w-32 rounded" />
                      <SkeletonBlock className="h-3 w-24 rounded" />
                    </div>
                  </td>
                  <td className="whitespace-nowrap py-4 pl-4 pr-3 sm:pl-6 md:pl-0">
                    <div className="space-y-2">
                      <SkeletonBlock className="h-4 w-24 rounded" />
                      <SkeletonBlock className="h-3 w-36 rounded" />
                    </div>
                  </td>
                  <td className="whitespace-nowrap py-4 px-3">
                    <SkeletonBlock className="h-6 w-20 rounded-full" />
                  </td>
                  <td className="whitespace-nowrap py-4 px-3">
                    <div className="space-y-2">
                      <SkeletonBlock className="h-4 w-16 rounded" />
                      <SkeletonBlock className="h-3 w-24 rounded" />
                    </div>
                  </td>
                  <td className="whitespace-nowrap py-4 pr-3">
                    <SkeletonBlock className="h-6 w-16 rounded-full" />
                  </td>
                  <td className="whitespace-nowrap py-4 px-3">
                    <SkeletonBlock className="h-4 w-20 rounded" />
                  </td>
                  <td className="whitespace-nowrap py-4 pr-3">
                    <SkeletonBlock className="h-6 w-24 rounded-full" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-4 flex w-full flex-col justify-between gap-3 sm:flex-row sm:items-center">
            <SkeletonBlock className="h-4 w-56 max-w-full rounded" />
            <div className="flex gap-2">
              <SkeletonBlock className="h-8 w-28 rounded" />
              <SkeletonBlock className="h-8 w-24 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrdersSkeleton;
